import ImageLayer from "../ImageLayer";
import { LayerCustomType } from "../../interfaces";
import { ClockLayerProps, ClockProps } from "./interfaces";

export default class ClockLayer extends ImageLayer {
  protected static customType: LayerCustomType = LayerCustomType.Clock;
  protected static defaultTypeProps: ClockProps = {
    meridiemRadius: 0.25,
    hour: 10,
    minute: 10,
    meridiem: "AM",
  };

  name: string = "Clock layer";
  clockProps: Partial<ClockProps>;

  constructor(options: Partial<ClockLayerProps> = {}) {
    const {
      transformSettings = {},
      typeSettings = {},
      ...layerProps
    } = options;
    super();

    const clockTypeSettings = typeSettings as Partial<ClockProps>;
    this.clockProps = { ...ClockLayer.defaultTypeProps, ...clockTypeSettings };

    this.set(transformSettings);
    this.set(layerProps);
  }

  toObject() {
    const object = super.toObject();
    return { ...object, typeSettings: this.getClockProps() };
  }

  setClockProps(props: Partial<ClockProps>) {
    this.clockProps = { ...this.clockProps, ...props };
    this.rerender();
  }

  getClockProps<T extends keyof ClockProps>(key: T): Partial<ClockProps>[T];
  getClockProps(): Partial<ClockProps>;
  getClockProps<T extends keyof ClockProps>(key?: T) {
    if (key) {
      return this.clockProps?.[key];
    }

    return { ...this.clockProps };
  }
}

export * from "./interfaces";
